import { createSelector } from 'reselect';
import { RootState } from 'store';

export const getPaymentMethodsState = (state: RootState) => state.paymentMethods;

export const getPaymentMethodsLoading = createSelector(
    getPaymentMethodsState,
    state => state.loading
);

export const getPaymentMethodsFetched = createSelector(
    getPaymentMethodsState,
    state => state.paymentMethodsFetched
);

export const getSortedPaymentMethods = createSelector(getPaymentMethodsState, state =>
    [...state.paymentMethods].sort((a, b) => {
        if (a.primary && !b.primary) return -1;
        if (!a.primary && b.primary) return 1;
        return a.id - b.id;
    })
);

export const getAdyenSession = createSelector(getPaymentMethodsState, state => state.adyenSession);

export const getSessionLoading = createSelector(
    getPaymentMethodsState,
    state => state.sessionLoading
);

export const getSurchargeQuote = createSelector(
    getPaymentMethodsState,
    state => state.surchargeQuote
);

export const getSurchargeLoading = createSelector(
    getPaymentMethodsState,
    state => state.surchargeLoading
);

export const getTokenPaymentStatus = createSelector(
    getPaymentMethodsState,
    state => state.tokenPaymentStatus
);
